import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";



const enum fields {
    partnumberlabel = "partnumberlabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.partnumberlabel]: string;
    };
}

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    fitContent?: InjectableCss;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: .18750625rem;
            white-space: nowrap;
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: .31250625rem;
        `,
    },
    fitContent: {
        css: css`
        width: fit-content;
        float:left;
        padding-right:.3rem;
         }
        `,
    },
};

const styles = partNumberStyles;

const ProductDetailsPartNumber: React.FC<Props> = ({ fields, product }) => {
    if (!product.productNumber) {
        return null;
    }

    return (
        <Typography {...styles.valueText} {...styles.fitContent} as="p" data-test-selector="ProductDetailsPartNumber">
            <Typography {...styles.labelText}>
                {translate(fields.partnumberlabel) || translate("TT Part:")}
            </Typography>
            {product.productNumber}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumber),
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.partnumberlabel,
                editorTemplate: "TextField",
                defaultValue: "TT Part:",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
